import { EProjectTypes } from "app/frontend/constants/enums";

export const MICROMOBILITY_CONTRACTORS_HREF_PLACEHOLDER = "micromobility_contractors_url";

export const QUICK_LINKS = [
    {
        header: "Electric Vehicle Charging Cost Calculator",
        body: "Estimate your fuel cost savings and help your customers choose the most cost-effective rate for their business.",
        linkText: "Use Calculator",
        href: "https://charging.coned.com/",
        projects: [EProjectTypes.ALL],
    },
    {
        header: "Micromobility Participating Contractor List",
        body: "View contractors who have represented themselves as qualified to perform in the Con Edison Micromobility PowerReady Program.**",
        linkText: "Participating Contractors",
        href: MICROMOBILITY_CONTRACTORS_HREF_PLACEHOLDER,
        projects: [EProjectTypes.ALL],
    },
    {
        header: "Medium- Heavy-Duty Pilot",
        body: "If your project has vehicles over 10,000 pounds, you may be eligible for incentives to offset utility-side and customer-side make-ready costs of installing charging infrastructure at qualifying sites.",
        linkText: "Check Eligibility",
        href: "https://www.coned.com/en/our-energy-future/electric-vehicles/medium-heavy-duty-ev-charging-infrastructure-program",
        projects: [EProjectTypes.ALL],
    },
];
